import styled from "react-emotion";

const Styled = {
  Container: styled("aside")`
    position: fixed;
    right: 0;
    top: 70px;
    width: 33%;
    min-width: 360px;
    height: calc(100vh - 70px);
    background: #0e0e0e;
    box-shadow: 0px 20px 0px 0 rgba(0, 0, 0, 0.05), -7px 3px 80px 0 rgba(0, 0, 0, 0.3),
      0px -3px 60px 0 rgba(0, 0, 0, 0.09);
    overflow: auto;
  `,
  Heading: styled("div")`
    position: fixed;
    width: calc(33% + 10px);
    min-width: 360px;
    z-index: 2;
    > * {
      position: relative;
      width: 100%;
      padding: 35px 25px 20px;
      height: 170px;
      background: #232323;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    h3 {
      margin: 0;
      font-size: 14px;
      color: #fefefe;
      font-weight: 700;
      text-transform: uppercase;
      span {
        color: #e91e63;
        text-transform: none;
        font-size: 25px;
        display: block;
      }
    }
  `,
  HeadingSwitch: styled("div")`
    width: 100%;
    display: flex;
    margin-top: 20px;
  `,
  Nav: styled("nav")`
    padding-top: 170px;
  `,
};

export default Styled;



// WEBPACK FOOTER //
// ./src/pages/tutorial/aside/Styled.jsx